import { Button, message } from "antd";
import React, { useEffect } from "react";
import { useAppSelector } from "../../app/hooks";
import { selectError } from "./errorsSlice";

const ERROR_MESSAGE_KEY = "global-error-message";

export default function ErrorAlerter() {
  const error = useAppSelector(selectError);

  let handleMessageClose = () => {
    message.destroy(ERROR_MESSAGE_KEY);
  };
  useEffect(() => {
    if (error?.message || error?.code) {
      let ErrorReceived = (
        <div>
          {error.message && <span>MESSAGE: {error.message}</span>}
          <br></br>
          {error.code && <span>CODE: {error.code}</span>}
          <br></br>
          <div className="center">
            <Button
              danger
              onClick={() => {
                handleMessageClose();
              }}
            >
              Close
            </Button>
          </div>
        </div>
      );
      const notice = {
        key: ERROR_MESSAGE_KEY,
        type: "warning" as const,
        content: ErrorReceived,
        duration: 5,
        pauseOnHover: false,
      };
      message.open(notice);
    }
  }, [error]);

  return <></>;
}
